import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import {
  ArrayField,
  DateField,
  Datagrid,
  Labeled,
  NumberField,
  RecordContextProvider,
  ReferenceField,
  SimpleShowLayout,
  TextField,
  Title,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import { CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS_DETAILS, StudentServicePath } from "utils/constants";
import { useNotifyError } from "utils/useNotifyError";

const ShowCurriculumSelectionCampaignApplication = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notifyError = useNotifyError();

  const location = useLocation();
  const campaignId = location?.state?.campaignId;
  const applicationId = location?.state?.applicationId;

  const [details, setDetails] = useState(null);

  const fetchDetails = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getCurriculumSelectionCampaignApplicationById(campaignId, applicationId),
      );
      setDetails(data);
    } catch (err) {
      notifyError(err);
    }
  }, [campaignId, applicationId, notifyError]);

  useEffect(() => {
    if (!campaignId || !applicationId) return;
    fetchDetails();
  }, [campaignId, applicationId, fetchDetails]);

  return (
    <RecordContextProvider value={details}>
      <Title title="Детайли на кандидатура" />
      <BackButtonToolbar />

      <SectionTitle
        title="Основна информация"
        textAlign="center"
        paddingY={0}
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Факултетен номер">
              <TextField source="facultyNumber" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Бал">
              <NumberField source="score" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Класиран учебен план">
              <ReferenceField
                source="assignedCurriculumId"
                reference={studentRequests.getCurriculumsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Класиран на">
              <DateField
                source="rankedOn"
                showTime
                locales="bg-BG"
              />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
      <SectionTitle
        title="Предпочитания"
        textAlign="center"
        paddingY={0}
        sx={{ marginTop: "2rem" }}
      />

      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <ArrayField
              source="choices"
              label=""
            >
              <Datagrid
                resource={StudentServicePath + CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS_DETAILS}
                bulkActionButtons={false}
                rowClick={false}
                sx={settings.style.detailsDatagrid}
              >
                <ReferenceField
                  source="curriculumId"
                  reference={studentRequests.getCurriculumsSelect()}
                  label="Учебен план"
                  sortable={false}
                >
                  <TextField source="name" />
                </ReferenceField>
                <NumberField
                  source="priority"
                  label="Приоритет"
                  sortable={false}
                />
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </RecordContextProvider>
  );
};

export default ShowCurriculumSelectionCampaignApplication;
